import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import SubNav from "../../navbar/subNav";
import "./ViewPropertyDetails.css";
import CustomModal from "../../input-components/Modal";
import ShowValue from "../../input-components/ShowValue";
import { gettenantfoliosbyproperty, assignedTo, addupdatetenantpaymentmethod  } from "../../../components/CommonSection/apiresources";
import { makeRequestWithSpinner } from "../../../Utilities/client";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus } from "../../../Utilities/enum";
import AddTenant from "./TenantPropertyAgency";
import AddTenantFolio from "./TenantFolio"
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Table, Button, Select, Input, Space, Tag  } from "antd";
import { PlusOutlined, DollarOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import { FormatDateView } from "../../../components/CommonSection/Utility/Utility";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { dynamicUrl } from "../../../Utilities/profileManagement";


const ManageTennat = ({ }) => {
    const [userId, setUserId] = useState("");
    const [userUId, setUserUId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [agencyUID, setAgencyUID] = useState("");
    const navigate = useNavigate();
    const [activeTabTenant, setActiveTabTenant] = useState("Tenant");
    const [openAddNewtenant, setOpenAddNewtenant] = useState(false);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [getDetails, setGetDetails] = useState(null);
    const [tenantCollapse, setTenantCollapse] = useState(true);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [dpdata, setDpdata] = useState([]);
    const [tenantId, setTenantId] = useState(null);
    const [tenantEdit, setTenantEdit] = useState(false);
    const [ folioId,setFolioId] = useState(null)
    const ePaymentModes = [
        { value: 5, label: "BPay" },
        { value: 4, label: "EFT" }
    ];
    const [tenantFormData, setTenantFormData] = useState(null);

    var url = new URL(window.location.href);
    var propertyUId = url.searchParams.get("propertyUID");
    var step = url.searchParams.get("step");

    const ToastRef = useRef();

    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserUId(parsedData.userUnique_ID);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                    setAgencyUID(parsedData.agencyUniqueID);
                    reportData(parsedData.agencyUniqueID);

                } else {
                    navigate("/signin");
                }
            } catch (error) {
                console.error("Error retrieving data:", error);
            }
        };
        retrieveData();
    }, [userId]);

    const reportData = (agencyUID) => {
        const apiUrl = assignedTo;
        const baseUrl = apiUrl + "?agencyUID=" + agencyUID;
        axios.get(baseUrl).then((response) => {
            if (response.data.object) setDpdata(response.data.object);
        });
    };


    useEffect(() => {
        getPropertyDetails(propertyUId);
        if (step === "tenant") {
            setOpenAddNewtenant(true);
            setActiveTabTenant("Rent Details")
        }
    }, [])

    const getPropertyDetails = (value, rent) => {
        debugger
        const baseUrl = gettenantfoliosbyproperty;
        const apiUrl = `${baseUrl}?PropertyUniqueId=${value}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    setGetDetails(response.object);
                }
            })
          
    };
    

    const closeTenant = () => {
        setOpenAddNewtenant(false);
        getPropertyDetails(propertyUId);
        setActiveTabTenant("Tenant")
        setTenantEdit(false)
    }

    const handleOpenAddTenant = (id = null, edit = false, rent = null) => {
       

        setOpenAddNewtenant(true);

        if (edit) {
            setTenantEdit(true);
            setTenantId(id); // Set specific tenant ID for editing
            if (rent) {
                setActiveTabTenant(rent);
            }
        } else {
            setTenantEdit(false);
            setTenantId(null); // Reset ID for fresh form
        }
    };

    const tenantTabs = ["Tenant", "Rent Details", "Payment Method"]


    const handleTenant = () => {
        setTenantCollapse(!tenantCollapse)
    }

    const handlefolio = (data,folio) => {
         dynamicUrl(navigate, `accounts/folio?type=${data}&folio=${folio}`);
    }

    const handleTabChangeTenant = (id, val,folioId) => {
        getPropertyDetails(propertyUId);
        setActiveTabTenant(val);
        if(val === "Payment Method"){
        setFolioId(folioId);
        }
    }


    const columns2 = [
        {
            title: "Method",
            dataIndex: "method",
            render: (value, row, idx) => (
                <Select
                    style={{ width: "100%" }}
                    value={value}
                    onChange={(val) => updateField(idx, "method", val)}
                >
                    {ePaymentModes.map((mode) => (
                        <Option key={mode.value} value={mode.value}>
                            {mode.label}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: "Payee",
            dataIndex: "payee",
            render: (value, row, idx) => (
                <Input value={value} onChange={(e) => updateField(idx, "payee", e.target.value)} />
            ),
        },
        {
            title: "BSB",
            dataIndex: "bsb",
            render: (value, row, idx) => (
                <Input
                    maxLength={6}
                    value={row.bsb}
                    onChange={(e) => {
                        const val = e.target.value;
                        // Allow only digits
                        if (/^\d{0,6}$/.test(val)) {
                            updateField(idx, "bsb", val);
                        }
                    }}
                    status={row.bsb && row.bsb.length !== 6 ? "error" : ""}
                />
            ),
        },
        {
            title: "Account #",
            dataIndex: "account",
            render: (value, row, idx) => (
                <Input value={value} onChange={(e) => updateField(idx, "account", e.target.value)} />
            ),
        },
        {
            title: "Split",
            dataIndex: "split",
            render: (value, row, idx) => {
                const isLast = idx === paymentMethods.length - 1;
                const isPercentageCount = paymentMethods.filter((p) => p.isPercentage).length;
                const isReadOnly = row.isPercentage && isPercentageCount > 1 && isLast;

                return (
                    <Space>

                        <Input
                            type="number"
                            style={{ width: 100 }}
                            value={value}
                            readOnly={isReadOnly}
                            variant={isReadOnly ? "filled" : ""}
                            onChange={(e) => handleSplitChange(idx, e.target.value)}
                        />
                    </Space>
                );
            },
        },
        {
            title: "Action",
            render: (_, __, idx) => (
                <DeleteOutlined style={{ color: 'red' }} onClick={() => handleRemovePaymentMethod(idx)} />
            ),
        },
    ];

    const handleAddPaymentMethod = () => {
        setPaymentMethods((prev) => {
            const totalSplit = prev.reduce((acc, p) => acc + (p.isPercentage ? (p.split || 0) : 0), 0);
            const remaining = 100 - totalSplit;
            return [...prev.map(p => ({ ...p })), { method: 4, payee: "", bsb: "", account: "", split: prev.length === 0 ? 100 : 0, isPercentage: true }];
        });
    };


    // 4. Remove Row
    const handleRemovePaymentMethod = (index) => {
        setPaymentMethods((prev) => prev.filter((_, i) => i !== index));
    };
    const updateField = (idx, field, value) => {
        const updated = [...paymentMethods];
        updated[idx][field] = value;
        setPaymentMethods(updated);
    };

    const handleSplitChange = (index, value) => {
        const updated = [...paymentMethods];
        const val = parseFloat(value) || 0;
        updated[index].split = val;

        const percentageRows = updated.filter(p => p.isPercentage);

        if (percentageRows.length > 1) {
            const totalExcludingLast = percentageRows
                .slice(0, -1)
                .reduce((acc, p) => acc + (parseFloat(p.split) || 0), 0);

            const lastIdx = [...updated]
                .map((p, i) => ({ ...p, index: i }))
                .filter(p => p.isPercentage)
                .pop()?.index;

            if (lastIdx !== undefined) {
                updated[lastIdx].split = Math.max(0, 100 - totalExcludingLast);
            }
        }

        setPaymentMethods(updated);
    };



    const handleUpdatePaymentMethos = () => {

        const totalPercentage = paymentMethods
            .filter(p => p.isPercentage)
            .reduce((acc, p) => acc + (p.split || 0), 0);

        if (paymentMethods.length > 0 && totalPercentage !== 100) {
            ToastRef.current.notify(["error", "Total split percentage must equal 100%."]);
            return;
        }

        const missingMethod = paymentMethods.find(p => p.method === undefined || p.method === null || p.method === "");
        if (paymentMethods.length > 0 && missingMethod) {
            ToastRef.current.notify(["error", "Please select a payment method for all rows."]);
            return;
        }

        // 2. Validate BSB format (6 digits)
        const invalidBSB = paymentMethods.find(
            p => p.method !== 2 && (!/^\d{6}$/.test(p.bsb || ""))
        );

        if (paymentMethods.length > 0 && invalidBSB) {
            ToastRef.current?.notify(["error", "Each BSB must be exactly 6 digits."]);
            return;
        }

        if (paymentMethods.length > 0 && invalidBSB) {
            ToastRef.current?.notify(["error", "Each BSB must be exactly 6 digits."]);
            return;
        }

        const payload = {
            FolioCode: folioId ? folioId :  getDetails.tenantFolioDetails?.tenantAccountFolio,
            OwnerPaymentMethodDetails: paymentMethods.map((pm) => ({
                Id: 0,
                PaymentMethod: pm.method,
                ChequePayeeName: pm.method === 2 ? pm.payee : null,
                AccountName: pm.method === 2 ? null : pm.payee,
                AccountBSB: pm.method === 2 ? null : pm.bsb,
                AccountNumber: pm.method === 2 ? null : pm.account,
                BpayPayee: "",
                BillerCode: "",
                Split: pm.split,
                SplitType: pm.isPercentage ? 1 : 2
            })),
            NewTenant: true,
        };

        makeRequestWithSpinner(showSpinner, hideSpinner, addupdatetenantpaymentmethod, "post", payload)
            .then((res) => {
                if (res.status === 1) {
                    ToastRef.current.notify(["success", res.message]);
                    closeTenant()
                } else {
                    ToastRef.current.notify(["error", res.message]);
                }
            })
    };

const renderAllTenants = () => {
    const tenants = getDetails?.tenantFolioDetailWithContact || [];

    // Sort to ensure current tenant appears first
    const sortedTenants = [...tenants].sort((a, b) => {
        if (a.isCurrent && !b.isCurrent) return -1;
        if (!a.isCurrent && b.isCurrent) return 1;
        return 0;
    });

    return sortedTenants.map((tenant, index) => (
        <div className="mb-2" key={`tenant-${index}`}>
            <div className="detailsContainer">
                <div className="sectionHeader d-flex justify-content-between">
                    <span>
                        {tenant.contact} {tenant.isCurrent ? <Tag color="geekblue">Current</Tag> : null}
                    </span>
                    <div title="view folio" className="editbtn ml-3" onClick={() => handlefolio("Tenant", tenant.tenantFolio)}>
                        <DollarOutlined className="mr-1" /> Folio
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6 owner-details">
                        <ShowValue Label="Contact" setData={tenant.contact || "-"} />
                        <ShowValue Label="Phone" setData={tenant.phone || "-"} />
                        <ShowValue Label="Rent" amt={true} setData={tenant.rent} />
                        <ShowValue Label="Rent period" setData={tenant.sPeriod || "-"} />
                        <ShowValue Label="Moved in" setData={FormatDateView(tenant.moveIn)} />
                        {tenant.moveOut ? <ShowValue Label="Moved out" setData={FormatDateView(tenant.moveOut)} /> : ""}
                    </div>
                    <div className="col-6 owner-details">
                        <ShowValue Label="Folio" setData={tenant.tenantFolio} />
                        <ShowValue Label="Email" setData={tenant.email || "-"} />
                        <ShowValue Label="Bond amount" amt={true} setData={tenant.bondAmount} />
                        <ShowValue Label="Bank reference" setData={"-"} />
                        <ShowValue Label="Agreement start" setData={FormatDateView(tenant.agreementStart)} />
                    </div>
                </div>
            </div>
        </div>
    ));
};


const handleTenantFormSubmit = (data) => {
    console.log(data,'dataaaaaaaaaa')
    setTenantFormData(data);
    setActiveTabTenant("Rent Details");
};


    return (
        <div>
            <div className="col-12 px-0 changedateantdstyle">
                <div className="col-12 px-0 daily-date-style">
                    <SubNav title={`Manage Tenants - ${getDetails?.propertyAddress}`} goback={true} extraData={true}/>
                    <ToastAlert ref={ToastRef} />
                        <div className="material-work-desk-new bg-white m-3" style={{ fontFamily: 'Inter' }}>
                            <div className="p-3">
                                <>
                                    {getDetails?.tenantFolioDetailWithContact?.length > 0 ?
                                        <div>
                                            {getDetails?.tenantFolioDetailWithContact?.length > 0 ?
                                                <div className="d-flex justify-content-between detailsCollapse mt-2" >
                                                    <div onClick={handleTenant}>{tenantCollapse ? <IoIosArrowDown style={{ fontSize: "20px" }} /> : <IoIosArrowUp style={{ fontSize: "20px" }} />} Tenant Details</div>
                                                    <div className="d-flex">
                                                        <div className="d-flex align-items-center detailsCollapse mr-2" onClick={handleOpenAddTenant}><img src="/assets/images/add.png" width={25} /> Add Tenants</div>
                                                        {/* <div className="editbtn " onClick={() => handleOpenAddTenant(primarytenantDetails[0]?.tenantId, "edit")}>
                                                            <EditOutlined className="mr-1" /> Edit
                                                        </div> */}
                                                        
                                                    </div>
                                                </div> : null}
                                            {tenantCollapse && (
                                                <div className="mt-2">
                                                    {renderAllTenants()}
                                                </div>
                                            )}
                                        </div> : 
null                                        }
                                </>
                            </div>

                            <CustomModal
                                title={tenantEdit ? "Update Tenant" : "Add Tenant"}
                                width={800}
                                closable={closeTenant}
                                visible={openAddNewtenant}
                                onCancel={closeTenant}
                                modalData={
                                    <div>
                                        <div style={{ display: "flex", padding: "5px", background: 'white' }}>
                                            {tenantTabs.map((tab) => (
                                                <div
                                                    key={tab}
                                                    className={`button ${activeTabTenant === tab ? "active-tab" : ""}`}
                                                    onClick={() => setActiveTabTenant(tab)}
                                                >
                                                    {tab}
                                                </div>
                                            ))}
                                        </div>
                                        {activeTabTenant === "Tenant" ?
                                            <AddTenant manageTenant={true} tenantId={tenantEdit ? tenantId : null} cancel={closeTenant} getDetails={getDetails} tabChange={handleTabChangeTenant} onTenantFormSubmit={handleTenantFormSubmit}/> :
                                            activeTabTenant === "Rent Details" ?
                                                <AddTenantFolio manageTenant={true} tenantId={tenantEdit ? tenantId : null} cancel={closeTenant} getDetails={getDetails} tabChange={handleTabChangeTenant} tenantFormData={tenantFormData}/> :
                                                <div>
                                                    <Table
                                                        columns={columns2}
                                                        dataSource={paymentMethods.map((item, index) => ({ ...item, key: index }))}
                                                        pagination={false}
                                                        footer={() => (
                                                            <div style={{ textAlign: "right" }}>
                                                                <Button icon={<PlusOutlined />} type="dashed" onClick={handleAddPaymentMethod}>
                                                                    Add
                                                                </Button>
                                                            </div>
                                                        )}
                                                    />
                                                    <div className="property-details-buttons">
                                                        <button className="pdb-cancel" type="reset" onClick={closeTenant}>
                                                            Cancel
                                                        </button>
                                                        <button
                                                            className="pdb-save-changes"
                                                            type="button"
                                                            onClick={handleUpdatePaymentMethos}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                }
                                footer={null}
                            />
                        </div>
                   
                </div>
            </div>
        </div>
    );
};

export default ManageTennat;


